import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment as env } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class AnnouncementsService {

  constructor(private readonly http: HttpClient) { }
  private readonly apiUrl = `${env.apiUrl}/notification/v1/announcement`;

  createAnnouncement(client_id: any, payload: any) {
    return this.http.post(`${this.apiUrl}/create?client_id=${client_id}`, payload);
  }
  updateAnnouncement(client_id: any, payload: any,id:any) {
    return this.http.put(`${this.apiUrl}/${id}?client_id=${client_id}`, payload);
  }
  deleteAnnouncement(client_id: any, id:any) {
    return this.http.delete(`${this.apiUrl}/${id}?client_id=${client_id}`);
  }
  getAnnoucementsGrid(payload:any) {
    return this.http.post(`${this.apiUrl}/admin/list`,payload);
  }
  getAnnouncements(payload: any) {
    return this.http.post(`${this.apiUrl}/list`, payload);
  }
  getAnnouncementsExport(payload: any) {
    return this.http.post(`${this.apiUrl}/admin/list`, payload, { responseType: 'blob' });
  }
 
}
